import React, { useEffect } from "react";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Group,
  Input,
  Loader,
  Popover,
  ScrollArea,
  Table,
  Text,
  createStyles,
} from "@mantine/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import TableLoader from "../TableLoader";
import NoteModalNew from "../NoteModal/NoteModalNew";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { decrypt, formatDate, formatTime } from "../../utils";
import { isLate } from "../../pages/Home/Medication/MarLogTab/MarLogTable";
import NotFound from "../../pages/Home/Medication/NotFound";
import { IconRefresh, IconSearch, IconTrash } from "@tabler/icons-react";
import { deleteMar } from "../../services";
import useDebounce from "../../utils/useDebounce";
import { getTodaysMAR } from "../../services/dashboard";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    "& th": {
      backgroundColor: "#fff",
      color: "#000 !important",
    },

    transition: "box-shadow 150ms ease",
  },

  scrolled: {
    // boxShadow: theme.shadows.sm,
  },
  bg1: {
    "& td": {
      background: "#fff",
    },
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
  },
  loaderHeight: {
    height: "340px",
  },
  notFoundTextContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "460px",
  },
  searchInput: {
    width: "50%",
    marginBlock: "10px",
    borderRadius: "8px",
    "& :focus-within": {
      border: "1px solid #ccc",
    },
    "& :focus": {
      border: "1px solid #ccc",
    },
    "& :hover": {
      border: "1px solid #ccc",
    },
    "& :active": {
      border: "1px solid #ccc",
    },
    "& :focus-visible": {
      border: "1px solid #ccc",
    },
  },
}));

export function MARDashTable() {
  const { mars, marLoading } = useSelector((state) => state?.dashboard);
  const { classes, cx } = useStyles();
  const [scrolled, setScrolled] = useState(false);
  const [isopen, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [noteType, setNoteType] = useState(null);
  const [view, setView] = useState(false);

  // const [searchTerm, setSearchTerm] = useState("");
  // const debouncedSearch = useDebounce(searchTerm, 2000);

  // useEffect(() => {
  //   if (debouncedSearch) {
  //     getTodaysMAR("daily", debouncedSearch);
  //   }
  // }, [debouncedSearch, getTodaysMAR]);

  const getColor = (key) => {
    const color = {
      Taken: "#027A48",
      Missed: "#B42318",
      Refused: "#6B9CFF",
      "Unable to Take": "rgba(255, 186, 69, 0.70)",
      Upcoming: "#a7a2a2",
      //  discontinued :"#8B4513"
    };
    return color[key];
  };
  const getBadgeColor = (key) => {
    const color = {
      Taken: "#12B76A",
      Missed: "#F04438",
      Refused: "#6B9CFF",
      "Unable to Take": "rgba(255, 186, 69, 0.70)",
      Upcoming: "#a7a2a2",
    };
    return color[key];
  };
  const getBGColor = (key) => {
    const color = {
      Taken: "#16720733",
      Missed: "#ff000014",
      Refused: "#c7daf57a",
      "Unable to Take": "#ffff8066",
      Upcoming: "#a7a2a257",
    };
    return color[key];
  };

  // const DeleteComponent = ({ data }) => {
  //   const [deleteModal, setDeleteModal] = useState(false);
  //   const [dltLoading, setDltLoading] = useState(false);

  //   const removeMedication = async () => {
  //     // setDltLoading(true);
  //     const obj = {
  //       client: data?.client?.id,
  //       marId: data?._id,
  //       type: data?.medicationType === "PRN" ? "prn" : "scheduled",
  //     };
  //     await deleteMar(obj);
  //     setDltLoading(false);
  //     setDeleteModal(false);
  //   };
  //   return (
  //     <Popover
  //       opened={deleteModal}
  //       width={300}
  //       position="bottom"
  //       withArrow
  //       shadow="md"
  //     >
  //       <Popover.Target>
  //         <ActionIcon
  //           color="red"
  //           variant="light"
  //           onClick={() => setDeleteModal(true)}
  //         >
  //           {data?.medicationType === "PRN" ? <IconTrash /> : <IconRefresh />}
  //         </ActionIcon>
  //       </Popover.Target>
  //       <Popover.Dropdown>
  //         <Text size="sm">
  //           Are you sure you want to{" "}
  //           {data?.medicationType === "PRN" ? "Delete" : "Reset"}?
  //         </Text>

  //         <Group grow mt={10}>
  //           <Button
  //             onClick={() => setDeleteModal(false)}
  //             size={"xs"}
  //             color="yellow"
  //           >
  //             Cancel
  //           </Button>
  //           <Button
  //             marLoading={dltLoading}
  //             size={"xs"}
  //             color={"red"}
  //             onClick={removeMedication}
  //           >
  //             {data?.medicationType === "PRN" ? "Delete" : "Reset"}
  //           </Button>
  //         </Group>
  //       </Popover.Dropdown>
  //     </Popover>
  //   );
  // };

  return (
    <ScrollArea
      h={460}
      onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
    >
      <NoteModalNew
        opened={isopen}
        close={() => {
          setOpen(false);
          setData(null);
        }}
        noteType={noteType}
        title={"Add New Note"}
        view={view}
        setView={setView}
        data={data}
      />
      {/* <NoteDrawer
        title="Note"
        opened={isopen}
        close={() => {
          setOpen(false);
          setData(null);
        }}
        noteType={noteType}
        // title={"Add New Note"}
        view={view}
        setView={setView}
        data={data}
      /> */}

      <div style={{ overflowX: "auto" }}>
        <div style={{ minWidth: "600px" }}>
          {/* <Input
            icon={<IconSearch />}
            placeholder="Search"
            className={classes.searchInput}
            onChange={(e) => setSearchTerm(e.target.value)}
          />{" "} */}
          {marLoading ? (
            <Flex align="center" justify="center" h={460}>
              <Loader color="#FFBA45" />
            </Flex>
          ) : mars?.length > 0 ? (
            <Table
              withBorder
              fontSize={"sm"}
              // withColumnBorders
              verticalSpacing={"md"}
              sx={{ fontFamily: "Inter" }}
            >
              <thead
                className={cx(classes.header, { [classes.scrolled]: scrolled })}
              >
                <tr>
                  <th style={{ minWidth: "180px" }}>Client Name</th>
                  <th style={{ minWidth: "180px" }}>Medication Name</th>
                  <th style={{ minWidth: "180px" }}>Dosage</th>
                  <th style={{ minWidth: "180px" }}>Route</th>
                  <th style={{ minWidth: "180px" }}>Narcotic</th>
                  <th style={{ minWidth: "180px" }}>Remaining Qty</th>
                  <th style={{ minWidth: "180px" }}>Frequency</th>
                  <th style={{ minWidth: "180px" }}>Scheduled Time</th>
                  <th style={{ minWidth: "180px" }}>Administered Time</th>
                  <th style={{ minWidth: "180px" }}>Date</th>
                  <th style={{ minWidth: "180px" }}>Administered by</th>
                  <th style={{ minWidth: "180px" }}>Outcome</th>
                  {/* <th style={{ minWidth: "140px" }}>Late</th> */}
                  {/* <th style={{ minWidth: "140px" }}>Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {mars
                  ?.filter(
                    ({ medicationType }) =>
                      medicationType !== "discontinued" &&
                      medicationType !== "upcoming"
                  )
                  ?.map((row, i) => {
                    const _isLate = isLate(
                      row?.date,
                      row?.timeSlot,
                      row?.createdAt,
                      row?.medicationType
                    );
                    const bg = i % 2 === 0;
                    return (
                      <tr key={i} className={bg ? classes.bg2 : classes.bg1}>
                        <td>
                          {decrypt(row?.client?.name, false) ||
                            row?.client?.name ||
                            "-"}
                        </td>
                        <td>{row?.form3?.medicationName || "-"}</td>
                        <td>
                          {row?.form3?.dosage || "-"} {row?.form3?.unit || "-"}
                        </td>
                        <td>{row?.form3?.ingestionMode || "-"}</td>
                        <td>{row?.form3?.isNarcotic || "No"}</td>
                        <td>{row?.medicineRemaining || "-"}</td>
                        <td>{row?.form3?.frequency || "-"}</td>
                        <td>{row?.timeSlot || "-"}</td>
                        <td>
                          {row?.staff ? formatTime(row?.createdAt) : "-" || "-"}
                        </td>
                        <td>{formatDate(row?.date) || "-"}</td>

                        <td>{row?.staff?.name || "-"}</td>
                        <td
                          style={{
                            color: getColor(
                              row?.medicationType === "upcoming"
                                ? !moment(row.date).isBefore(
                                    moment().format("MM-DD-YYYY")
                                  )
                                  ? "Upcoming"
                                  : "Missed"
                                : row?.medicationType
                            ),
                            fontWeight: 700,
                          }}
                        >
                          <Box
                            style={{
                              backgroundColor: getBGColor(
                                row?.medicationType === "upcoming"
                                  ? !moment(row.date).isBefore(
                                      moment().format("MM-DD-YYYY")
                                    )
                                    ? "Upcoming"
                                    : "Missed"
                                  : row?.medicationType
                              ),
                              padding: "3px",
                              borderRadius: "30px",
                              textAlign: "center",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: "5px",
                              fontWeight: "400",
                            }}
                          >
                            <Badge
                              size="xs"
                              style={{
                                backgroundColor: getBadgeColor(
                                  row?.medicationType === "upcoming"
                                    ? !moment(row.date).isBefore(
                                        moment().format("MM-DD-YYYY")
                                      )
                                      ? "Upcoming"
                                      : "Missed"
                                    : row?.medicationType
                                ),
                              }}
                              circle
                            ></Badge>
                            {row?.medicationType === "upcoming"
                              ? !moment(row.date).isBefore(
                                  moment().format("MM-DD-YYYY")
                                )
                                ? "Upcoming"
                                : "Missed"
                              : row?.medicationType}
                          </Box>
                        </td>
                        {/* <td
                            style={{
                              color: _isLate === "Yes" ? "#F00" : "",
                              fontWeight: _isLate === "Yes" ? 700 : 400,
                            }}
                          >
                            {_isLate}
                          </td> */}
                        {/* <td>
                            <div style={{ display: "flex", gap: "5px" }}>
                              {profile?.user?.type !== "staff" &&
                                row?.medicationType !== "upcoming" && (
                                  <DeleteComponent data={row} />
                                )}
                            </div>
                          </td> */}
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          ) : (
            <div className={classes.notFoundTextContainer}>
              <p className={classes.notFoundText}>
                You don&apos;t have any record for Medication in last 24 hours
              </p>
            </div>
          )}
        </div>
      </div>
    </ScrollArea>
  );
}
